module.exports = __webpack_public_path__ + "media/icons/thief-60b799a2.svg";